module.exports = __webpack_public_path__ + "static/Slake-4a77ff8db89fab95118e37145f10159b.jpg";